import React, { useEffect, useState } from 'react';
import useAxios from '../axios/useAxios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CART, INVITATION, SCAN } from '../constants/routes';
import { notifyError, notifyInfo, notifySuccess, notifyWarning } from '../utils/Notify';
import { isAllowedToPay, MINIMUM_PRICE } from '../utils/Validator';
import BackButton from '../components/button/BackButton';
import HeaderCart from '../components/HeaderCart';
import UserInfo from '../components/UserInfo';
import StepBar from '../components/Step_bar';
import arrow from '../styles/img/arrow/arrow.svg';
import {
  USER_GET_FID_COUPONS_FAIL, USER_GET_FID_COUPONS_REQUEST, USER_GET_FID_COUPONS_SUCCESS,
} from '../constants/userConstants';
import PageLoader from '../components/loader/PageLoader';
import { CouponCard } from '../components/card/CouponCard';
import { CART_INFO_SUCCESS } from '../constants/cartConstants';
import LoaderWithText from '../components/loader/LoaderWithText';
import { useFunnelTracking } from '../posthog/funnelTracking';

const FidCouponScreen = () => {
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { store } = useSelector((state) => state.store);
  const { cartItems } = useSelector((state) => state.cart);
  const [isPopupVisible, setIsPopUpVisible] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [getCouponsLoading, setGetCouponsLoading] = useState(true);
  const [activateCouponLoadingId, setActivateCouponLoadingId] = useState(null);
  const { trackPageViewCoupon } = useFunnelTracking();
  
  useEffect(() => {
    trackPageViewCoupon({});
  }, [trackPageViewCoupon]);

  useEffect(() => {
    setTimeout(() => {
      setGetCouponsLoading(false);
    }, 2000);
  }, []);

  const handleNavigateToCart = () => {
    if (isAllowedToPay(cartItems)) {
      navigate(CART);
    } else {
      notifyWarning(
        `Panier inférieur à ${MINIMUM_PRICE}€`,
        'Le montant total du panier doit être d\'un montant minimum de 1€ pour passer à l\'étape de paiement.',
      );
    }
  };

  const handleActivateCoupon = async (coupon) => {

    setActivateCouponLoadingId(coupon.id_coupon);
    try {
      const response = await axiosInstance.post('/apiws/order/fid-coupon', {
        order: cartItems,
        coupon,
      });
      dispatch({ type: CART_INFO_SUCCESS, payload: response.data });
      localStorage.setItem('cartItems', JSON.stringify(response.data));
    } catch (error) {
      console.error('Erreur lors de l\'activation du coupon:', error);
      if (error?.response?.data?.message) {
        notifyError(error.response.data.message);
      } else {
        notifyError('Erreur', 'Impossible d\'activer le coupon');
      }
    } finally {
      setActivateCouponLoadingId(null);
    }
  };

  const handleDeactivateCoupon = async (coupon) => {

    setActivateCouponLoadingId(coupon.id_coupon);
    try {
      const response = await axiosInstance.put('/apiws/order/fid-coupon', {
        order: cartItems,
      });
      dispatch({ type: CART_INFO_SUCCESS, payload: response.data });
      localStorage.setItem('cartItems', JSON.stringify(response.data));
    } catch (error) {
      notifyError('Erreur', 'Une erreur s\'est produite');
    } finally {
      setActivateCouponLoadingId(null);
    }
  };

  useEffect(() => {
    const fetchCoupons = async () => {
      const fidNumber = user?.fidCard?.[0]?.fidelityInfo?.numeroClient;
      if (!fidNumber) return;

      dispatch({ type: USER_GET_FID_COUPONS_REQUEST });

      try {
        const { data } = await axiosInstance.get(`apiws/fidelity-card/${fidNumber}/coupons`);

        dispatch({ type: USER_GET_FID_COUPONS_SUCCESS });

        if (Array.isArray(data)) {
          setCoupons(data);
        }

      } catch (error) {
        dispatch({ type: USER_GET_FID_COUPONS_FAIL });
        notifyError('Erreur', 'Une erreur s\'est produite lors de la récupération des coupons');
      }
    };

    fetchCoupons();
  }, []);

  return (
    <>
      <div className="w-full h-full bg-white overflow-auto">
        <div className="global-header">
          {' '}
          <BackButton
            onClick={() => {
              navigate(SCAN);
            }}
          />
          <HeaderCart titre={'Promotions'} />
        </div>
        <div className={`contenaire_promo_screen `}>
          {user && user._id && user._id.length > 0 ? <UserInfo /> : <></>}
          {isPopupVisible ? (
            <div
              onClick={() => setIsPopUpVisible(false)}
              className="h-[100vh] z-[50] w-full fixed top-0 "
            ></div>
          ) : (
            <></>
          )}
          <StepBar step={1} />
          <div className=" p-6 flex flex-col gap-4 my-2 ">
            {getCouponsLoading || user?.userLoading ? (
              <LoaderWithText text="Chargement des coupons..." type2={true} className="!relative" />
            ) : (
              <>
                {coupons && coupons.length > 0 ? (
                  <div className="space-y-8 pb-[100px]">
                    {coupons.map((coupon) => (
                      <CouponCard
                        key={coupon.id_coupon}
                        data={coupon}
                        onActivate={handleActivateCoupon}
                        onDeactivate={handleDeactivateCoupon}
                        store={store}
                        cartItems={cartItems}
                        activateCouponLoadingId={activateCouponLoadingId}
                      />
                    ))
                    }
                  </div>
                ) : (
                  <div className="text-center py-8 text-gray-500">
                    <p>Tu n'as pas de coupon utilisable pour le moment.</p>
                  </div>
                )}
              </>
            )}
          </div>

        </div>
        <div className="promo-footer-button-container z-10">
          <button
            className={
              'non_merci_promo  w-[100%] ![animation-delay:_' + 0.75 + 's]'
            }
            onClick={handleNavigateToCart}
          >
            <span>
              Suivant <img src={arrow} alt="next" />
            </span>
          </button>
        </div>
      </div>
    </>
  );

};

export default FidCouponScreen;
